/*
 * @Description: 内容审核 dto
 * @Author: 山淑兰
 * @Date: 2019-12-17 17:35:25
 * @LastEditTime : 2019-12-25 14:55:08
 * @LastEditors  : 山淑兰
 */
export class GetContentAuditListDto {
  name: string = "";
}

export class GetWeightListDto {
  limit: number = 10; // 查看最近多少条
}
